import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class RoleModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (RoleModel._instance == null) RoleModel._instance = new RoleModel(authManager);
        return RoleModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/roles', 'core/roles/codelist');

        this.entityName = 'core.Role';
        this.privileges = {
            create: [["adminUsers"]],
            read: [["adminUsers"],["manageUsers"],["editUsers"],["readUsers"]],
            update: [["adminUsers"]],
            delete: [["adminUsers"]],
        };

        this.label = 'Role';
        this.setLabel = 'Roles';

        this.browser = {
            name: 'default-core-role-browser',
            moduleName: 'default-core-role-browser',
            moduleTitle: 'Roles',
            moduleStateSlotName: 'default-core-role-browser',
        };

        this.editor = {
            name: 'default-core-role-editor',
            moduleName: 'default-core-role-editor',
            moduleTitle: 'Role',
            moduleStateSlotName: 'default-core-role-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
